var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinRound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12m7.425-2.025c-.704 0-1.275.57-1.275 1.275v5.475a1.275 1.275 0 1 0 2.55 0V11.25c0-.704-.57-1.275-1.275-1.275M6 7.425c0 .825.6 1.425 1.425 1.425s1.425-.6 1.425-1.425S8.25 6 7.425 6C6.675 6 6 6.6 6 7.425m9.45 9.375a1.2 1.2 0 0 0 2.4 0v-3.75c0-2.475-1.5-3.3-2.925-3.3-.757 0-1.381.29-1.811.637-.162.13-.589-.012-.589-.22a.19.19 0 0 0-.192-.192h-1.008a1.2 1.2 0 0 0-1.2 1.2v5.55a1.275 1.275 0 1 0 2.55 0v-3c0-1.125.75-1.725 1.5-1.725s1.275.375 1.275 1.65z",
  clipRule: "evenodd"
})));
export default SvgLinkedinRound;